import 'css-chunksrc/client/pages/zonePage/reportsPage/loader/reportLoader/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_y068j_1",
  "input": "_input_y068j_10",
  "indicator": "_indicator_y068j_1",
  "name": "_name_y068j_28"
};